var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33.2396,
    fill: "url(#pattern0_509_1391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_509_1391",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_509_1391",
    transform: "matrix(0.0104167 0 0 0.0100282 0 0.0186464)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_509_1391",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACCklEQVR4nO2dTW7bMBQGdaZ24dys3SXLnIR477tbi94ggZEEcBPbkB1b74czgHZemDMSZJOEtCwAAAAAAAAAAABQC0m/xxi7pTljjN1+rEsm3P3J3V/M7J+ZPSxNkfTT3f++j/V5yST/4+gaQQfyD8b6nEp+1wg6Ij88win53SLojPywCPub0LkvdBih8o15jLHbj2HNWDe9MZvZDzP7szZCxStBK8780BOtcwRll985gqrI7xhB1eR3iqCq8jtEUHX5lSOoi/yKEdRNfqUI6iq/QgR1l585gmaRnzGCZpOfKYJmlZ8hgmaXHxlByI+LIOTHRRDy4yII+XERhPy4CEJ+XAQhPy6CkB8XQciP24tjbxFWfxb5d7gSHPm5Ixjy4yIY8uMiGPLjIhjyb4su+Kl57H8CbCjfiRAv34kQL9+JEC/fiXA5g6mIOHTFxFqGLS8t0DdmNYnwTXSDKWUiXIluOJ9PhAvRHRZTiLCSe65kGRHOs8UyohHhOFuu4RoR/idiAd2I8Ebk7gWbPUKGrSM2a4QM8qeNkEn+dBEyyp8mQmb57SNUkN82QiX57SJUlN8mQmX55SN0kF82Qif55SJ0lF8mQmf5JSLw6GL/cmz+TgF3/9VZ/iVXgpk9LhGcitBF/poIYfJPRegm/1yEcPmfI3SVfyxCGvkf8BIfAAAAAAAAAAAAWDLzCh3OrMrTFU+uAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.0a5001b7c67d1a2b4c3192e592c3e677.svg";
export { ForwardRef as ReactComponent };